import React from "react";
import searchIcon from "../../assets/images/search-icon.png";
import { getDisplayTitle } from "./NavbarSearch";

function MobileNavbarSearch({
  navigate,
  t,
  searchContainerRef,
  query,
  handleSearchChange,
  isSearching,
  showResults,
  searchResults,
  currentLang,
}) {
  return (
    <div className="tablet:hidden px-4 py-2 flex mt-2 justify-center z-50">
      <div className="relative w-[90%] max-w-[500px]" ref={searchContainerRef}>
        <input
          id="chapter-search-query"
          name="chapterSearchQuery"
          type="text"
          value={query}
          onChange={handleSearchChange}
          placeholder={t("search")}
          aria-label={t("search")}
          autoComplete="off"
          className="w-full px-3 py-2 border-0 rounded-md text-[#AAA] bg-[#191A1C] text-sm"
        />
        <img
          src={searchIcon}
          alt="Search Icon"
          className="absolute right-3 top-[10px] w-4 h-4 cursor-pointer"
        />
        {isSearching && (
          <span className="absolute right-10 top-[8px] text-white">⏳</span>
        )}
        {showResults && (
          <div className="absolute left-0 top-full mt-[5px] w-full min-h-[50px] max-h-[300px] bg-white border border-gray-300 rounded-md shadow-md overflow-y-auto z-50 opacity-100 transition-opacity duration-300 flex flex-col items-center">
            {searchResults.length > 0 ? (
              searchResults.map((book) => {
                const displayTitle = getDisplayTitle(book, currentLang);
                return (
                  <li
                    key={book.id}
                    onClick={() => navigate(`/book/${book.bookUrl}`)}
                    className="flex items-center gap-3 px-4 py-2 hover:bg-gray-200 cursor-pointer w-full"
                  >
                    <img
                      src={book.imageUrl}
                      alt={displayTitle}
                      className="w-10 h-10 rounded-md"
                    />
                    <div>
                      <span className="font-bold">{displayTitle}</span>
                      <br />
                      {book.author && (
                        <span className="text-sm text-gray-600">
                          {book.author}
                        </span>
                      )}
                    </div>
                  </li>
                );
              })
            ) : (
              <div className="flex justify-center items-center w-full h-full px-4 py-2 text-gray-600 text-center">
                {t("noResults")}
              </div>
            )}
            <li className="px-4 py-2 border-t border-gray-300 text-center w-full">
              <button
                className="text-blue-600 font-medium hover:underline w-full"
                onClick={() => navigate("/catalog")}
              >
                {t("advancedSearch")}
              </button>
            </li>
          </div>
        )}
      </div>
    </div>
  );
}

export default MobileNavbarSearch;
